import {handleAxiosError} from "./axiosErrorHandler";
import apiClient from "./baseService";
import {Notification, NotificationStatus, NotificationType} from "../types/domain/notification";

interface IGetNotificationProps {
    type?: NotificationType;
    page?: number;
    size?: number;
}

export interface IGetNotificationResponse {
    data: Notification[];
    total: string;
}

export const getNotifications = async ({type}: IGetNotificationProps = {}): Promise<IGetNotificationResponse> =>
    await apiClient
        .get<IGetNotificationResponse>("/notifications", {
            params: type ? {type} : {},
        })
        .then((response) => response.data)
        .catch(handleAxiosError);

export const getUserNotifications = async ({id}: {id: string}) => {
    return await apiClient
        .get<Notification[]>(`/notifications/users/${id}`)
        .then((response) => response.data)
        .catch(handleAxiosError);
};

export const postNotification = async (notification: Notification): Promise<Notification> =>
    await apiClient
        .post<Notification>(`/notifications`, notification)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const putNotification = async (id: string, notification: Partial<Notification>): Promise<Notification> =>
    await apiClient
        .put<Notification>(`/notifications/${id}`, notification)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const patchNotification = async (id: string, status: NotificationStatus): Promise<Notification> =>
    await apiClient
        .patch<Notification>(`/notifications/${id}/status`, {status})
        .then((response) => response.data)
        .catch(handleAxiosError);

export const notificationSeen = async (id: string): Promise<Notification> =>
    await apiClient
        .patch<Notification>(`/notifications/${id}/seen`)
        .then((response) => response.data)
        .catch(handleAxiosError);
